import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Upload, Megaphone, ArrowRight } from 'lucide-react';

export const HowItWorks = () => {
  const steps = [
    { icon: <Smartphone size={48} />, title: 'Book a Free Demo', description: 'Schedule a 30-minute call. We\'ll show you HungrMates in action and discuss your restaurant\'s specific needs, menu, and goals.', details: ['See a live demo of the app', 'Discuss your branding preferences', 'Get answers to all your questions', 'No pressure, no commitments'] },
    { icon: <Upload size={48} />, title: 'We Build Your App', description: 'Our team creates your custom branded mobile app. We handle everything — design, development, menu setup, and payment integration.', details: ['Custom branding with your colors and logo', 'Full menu setup and configuration', 'Payment processing integration', 'Staff training session included'] },
    { icon: <Megaphone size={48} />, title: 'Launch & Grow', description: 'Go live in just 2 weeks! We provide marketing materials, staff training, and ongoing support to help you maximize results.', details: ['Ready-to-use marketing materials', 'Table tents, posters, and QR codes', 'Ongoing technical support', 'Regular feature updates'] },
  ];

  const HERO_IMG = "https://customer-assets.emergentagent.com/job_23b5f19d-1a39-4e03-91cd-806fad7065f2/artifacts/64jdl678_IMG_0275.jpeg";

  return (
    <div>
      <section style={{ borderBottom: '4px solid #000', position: 'relative' }}>
        <img src={HERO_IMG} alt="Captain H supporting local restaurants" style={{ width: '100%', height: 'auto', display: 'block' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '3rem 1.5rem', background: 'linear-gradient(to top, rgba(0,0,0,0.85), transparent)', textAlign: 'center' }}>
          <h1 className="heading-1" style={{ marginBottom: '0.75rem', color: '#FFD700' }}>How It Works</h1>
          <p style={{ fontSize: '1.25rem', color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>From demo to launch in just 2 weeks. We handle the tech so you can focus on food.</p>
        </div>
        <div className="scroll-indicator" onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}>
          <span>Scroll</span>
          <div className="scroll-arrow" />
        </div>
      </section>

      <section style={{ padding: '5rem 1.5rem', background: '#fff', borderBottom: '4px solid #000' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          {steps.map((step, i) => (
            <div key={i} style={{ display: 'flex', gap: '2.5rem', marginBottom: i < steps.length - 1 ? '4rem' : 0, flexWrap: 'wrap', alignItems: 'flex-start' }}>
              <div style={{ flex: '0 0 auto' }}>
                <div style={{ width: '100px', height: '100px', borderRadius: '50%', background: '#FFD700', border: '4px solid #000', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '6px 6px 0px 0px #000', fontFamily: "'Bangers', cursive", fontSize: '3rem', color: '#000' }}>
                  {i + 1}
                </div>
              </div>
              <div style={{ flex: 1, minWidth: '280px' }}>
                <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '2rem', marginBottom: '0.75rem', color: '#000', letterSpacing: '0.03em', textTransform: 'uppercase' }}>{step.title}</h2>
                <p style={{ color: '#444', lineHeight: 1.6, marginBottom: '1.5rem', fontWeight: 500, fontSize: '1.1rem' }}>{step.description}</p>
                <div className="comic-card" style={{ padding: '1.25rem' }}>
                  {step.details.map((d, j) => (
                    <div key={j} style={{ display: 'flex', gap: '0.75rem', marginBottom: j < step.details.length - 1 ? '0.75rem' : 0, alignItems: 'center' }}>
                      <div style={{ width: '8px', height: '8px', borderRadius: '2px', background: '#6A0DAD', flexShrink: 0 }}></div>
                      <span style={{ color: '#333', fontWeight: 600 }}>{d}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="halftone-bg" style={{ padding: '5rem 1.5rem', background: '#6A0DAD', textAlign: 'center', position: 'relative' }}>
        <div className="container" style={{ maxWidth: '600px', position: 'relative', zIndex: 1 }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem', color: '#FFD700' }}>Ready to Get Started?</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem', fontWeight: 500, fontSize: '1.125rem' }}>Book a free demo and see exactly how HungrMates will work for your restaurant.</p>
          <Link to="/book-demo" className="btn-primary" style={{ fontSize: '1.125rem', padding: '16px 32px' }}>
            Book a Free Demo <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
          </Link>
        </div>
      </section>
    </div>
  );
};
